import { render, staticRenderFns } from "./body.vue?vue&type=template&id=5f19deea&"
import script from "./body.vue?vue&type=script&lang=js&"
export * from "./body.vue?vue&type=script&lang=js&"
import style0 from "./body.vue?vue&type=style&index=0&id=5f19deea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports